import * as Yup from "yup";

const nameLike = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;

export const workBagFormValidationSchema = Yup.object({
    name: Yup.string()
      .required("El campo es requerido.")
      .matches(nameLike, "Ingrese un formato válido"),
    lastname: Yup.string()
      .required("El campo es requerido.")
      .matches(nameLike, "Ingrese un formato válido"),
    email: Yup.string()
      .email("Ingrese un email válido")
      .required("El campo es requerido."),
    phone: Yup.string()
      .required("El campo es requerido.")
      .min(7, "Ingrese un teléfono válido"),
    skills: Yup.array()
      .min(1, "Seleccioná al menos un rubro")
      .required(),
    workZone: Yup.array()
      .min(1, "Agregá al menos una zona de trabajo")
      .required(),
    categoryConnect: Yup.array()
      .of(Yup.number())
      .min(1, "Seleccioná al menos una categoría de conexión")
      .required(),
    city: Yup.string(),
    unemploymentFund: Yup.boolean().required(),
    currentJob: Yup.boolean().required(),
    employmentEndDate: Yup.string().when(
      "currentJob",
      (currentJob: boolean, schema: Yup.StringSchema) =>
        currentJob ? schema.required("La fecha es requerida") : schema
    ),
    termsAndConditions: Yup.boolean()
      .oneOf([true], "Debes aceptar los términos y condiciones")
      .required(),
    selectedJurisdiction: Yup.mixed().nullable(),
  });
